import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/*
  This package link service provides util functions for navigating around the app.

  // Redirect to the URL for the given pathKey, pathArgs and queryParameters
  hardRedirect(pathKey, pathArgs = {}, queryParameters = {});

*/

/* eslint-disable default-param-last */
import { getCategoryNameByVariantId } from '../activityService';
var invalidPathKeyErrorMessage = 'provided pathKey is not valid';
var invalidNodeEnvErrorMessage = 'NODE_ENV is not set to known value';

// sets for different pages in the app
var activitiesAppPagesSet = new Set(['activities', 'activitiesById', 'newActivities', 'newActivity']);
var profilesAppPagesSet = new Set(['profile', 'my-profile', 'profileById', 'settings', 'preferences', 'profileBySlugOrId', 'create-experience-record', 'experience-record', 'timelineBySlugOrId']);
var exploreAppPagesSet = new Set(['explore', 'exploreProgram']);
var publicContentPagesSet = new Set(['publicActivitiesById', 'publicProfileById', 'publicProfileBySlugOrId', 'login', 'logout', 'landing', 'register', 'sitemap', 'sitemapPeopleDirectoryByLetter', 'sitemapLearningActivitiesById', 'notFoundPublic']);
var workspacePagesSet = new Set(['workspaceById', 'workspaceGatewayById', 'workspaceProgramById', 'workspaceProgramExperience', 'workspaceByRole']);
var organisationAppPagesSet = new Set(['createBusiness', 'organisationLanding', 'ourPeopleByOrganisationId', 'organisationLogout']);

// object that maps page sets to package names
var pathsInPackage = {
  activitiesApp: activitiesAppPagesSet,
  profilesApp: profilesAppPagesSet,
  exploreApp: exploreAppPagesSet,
  publicContent: publicContentPagesSet,
  workspaceApp: workspacePagesSet,
  organisationApp: organisationAppPagesSet
};
export var pathLinks = {
  // Public App is empty
  // Paddl App (Default to this package if link association not provided)
  jobs: function jobs() {
    return 'jobs';
  },
  basecamp: function basecamp() {
    return 'basecamp';
  },
  applications: function applications() {
    return 'applications';
  },
  onboarding: function onboarding() {
    return 'onboarding';
  },
  conversation: function conversation() {
    return 'conversation';
  },
  notFound: function notFound() {
    return 'not-found';
  },
  // Activities App'
  activities: function activities() {
    return 'activities';
  },
  activitiesById: function activitiesById(_ref) {
    var id = _ref.id;
    return "activities/".concat(id);
  },
  newActivities: function newActivities() {
    return 'activities/new';
  },
  newActivity: function newActivity(_ref2) {
    var id = _ref2.id;
    return "activities/new/".concat(getCategoryNameByVariantId(id), "/").concat(id);
  },
  // Profiles App'
  profileBySlugOrId: function profileBySlugOrId(_ref3) {
    var slug = _ref3.slug,
      id = _ref3.id;
    return "xp/".concat(slug || id);
  },
  timelineBySlugOrId: function timelineBySlugOrId(_ref4) {
    var slug = _ref4.slug,
      id = _ref4.id;
    return "xp/".concat(slug || id, "#tab-activities");
  },
  profileById: function profileById(_ref5) {
    var id = _ref5.id;
    return "xp/".concat(id);
  },
  profile: function profile() {
    return 'xp';
  },
  'my-profile': function myProfile() {
    return 'profiles/my-profile';
  },
  settings: function settings() {
    return 'settings';
  },
  preferences: function preferences() {
    return 'settings';
  },
  'create-experience-record': function createExperienceRecord() {
    return 'add-experience';
  },
  'experience-record': function experienceRecord(_ref6) {
    var id = _ref6.id;
    return "experience/".concat(id);
  },
  // Explore App'
  explore: function explore() {
    return 'explore';
  },
  exploreProgram: function exploreProgram(_ref7) {
    var programId = _ref7.programId;
    return "explore/program/".concat(programId);
  },
  // Public Content
  publicActivitiesById: function publicActivitiesById(_ref8) {
    var id = _ref8.id;
    return "xp/activities/".concat(id);
  },
  publicProfileById: function publicProfileById(_ref9) {
    var id = _ref9.id;
    return "xp/".concat(id);
  },
  publicProfileBySlug: function publicProfileBySlug(_ref10) {
    var slug = _ref10.slug;
    return "xp/".concat(slug);
  },
  publicProfileBySlugOrId: function publicProfileBySlugOrId(_ref11) {
    var slug = _ref11.slug,
      id = _ref11.id;
    return "xp/".concat(slug || id);
  },
  sitemap: function sitemap() {
    return 'sitemaps';
  },
  sitemapPeopleDirectoryByLetter: function sitemapPeopleDirectoryByLetter(_ref12) {
    var id = _ref12.id;
    return "sitemaps/people-directory/".concat(id);
  },
  sitemapLearningActivitiesById: function sitemapLearningActivitiesById(_ref13) {
    var categoryId = _ref13.categoryId,
      id = _ref13.id;
    return "/sitemaps/learning-activities/".concat(categoryId, "/").concat(id);
  },
  login: function login() {
    return 'api/auth/login';
  },
  logout: function logout() {
    return 'api/auth/logout';
  },
  register: function register() {
    return 'register';
  },
  landing: function landing() {
    return '';
  },
  notFoundPublic: function notFoundPublic() {
    return '404';
  },
  // Workspace app
  workspaceById: function workspaceById(_ref14) {
    var id = _ref14.id;
    return "workspace/".concat(id);
  },
  workspaceByRole: function workspaceByRole(_ref15) {
    var id = _ref15.id,
      role = _ref15.role;
    if (role === 'invited') return "workspace/".concat(id, "/gateway");
    if (['member', 'admin', 'owner'].includes(role)) return "workspace/".concat(id);
    return 'explore';
  },
  workspaceGatewayById: function workspaceGatewayById(_ref16) {
    var id = _ref16.id;
    return "workspace/".concat(id, "/gateway");
  },
  workspaceProgramById: function workspaceProgramById(_ref17) {
    var organisationId = _ref17.organisationId,
      programId = _ref17.programId;
    return "workspace/".concat(organisationId, "/program/").concat(programId);
  },
  workspaceProgramExperience: function workspaceProgramExperience(_ref18) {
    var organisationId = _ref18.organisationId,
      programId = _ref18.programId,
      experienceId = _ref18.experienceId;
    return "workspace/".concat(organisationId, "/program/").concat(programId, "/experience/").concat(experienceId);
  },
  // Organisation App
  organisationLanding: function organisationLanding() {
    return '';
  },
  createBusiness: function createBusiness() {
    return 'create-business-account';
  },
  organisationLogout: function organisationLogout() {
    return 'api/auth/logout';
  },
  ourPeopleByOrganisationId: function ourPeopleByOrganisationId(_ref19) {
    var organisationId = _ref19.organisationId;
    return "".concat(organisationId, "/members");
  }
};

// TODO: move the below values into .env file
export var packagePrefixes = {
  development: {
    publicContent: 'http://localhost:3033',
    paddlApp: 'http://localhost:9000',
    activitiesApp: 'http://localhost:3021',
    profilesApp: 'http://localhost:3073',
    exploreApp: 'http://localhost:3028',
    workspaceApp: 'http://localhost:3056',
    organisationApp: 'http://localhost:3000'
  },
  test: {
    publicContent: 'http://localhost:3033',
    paddlApp: 'http://localhost:9000',
    activitiesApp: 'http://localhost:3021',
    profilesApp: 'http://localhost:3073',
    exploreApp: 'http://localhost:3028',
    workspaceApp: 'http://localhost:3056',
    organisationApp: 'http://localhost:3000'
  },
  production: {
    publicContent: 'https://www.paddl.com',
    paddlApp: 'https://app.paddl.com',
    activitiesApp: 'https://app.paddl.com',
    profilesApp: 'http://app.paddl.com',
    exploreApp: 'https://app.paddl.com',
    workspaceApp: 'https://app.paddl.com',
    organisationApp: 'https://org.paddl.com'
  }
};
export var pathKeyToPackage = function pathKeyToPackage(pathKey) {
  if (activitiesAppPagesSet.has(pathKey)) return 'activitiesApp';
  if (profilesAppPagesSet.has(pathKey)) return 'profilesApp';
  if (exploreAppPagesSet.has(pathKey)) return 'exploreApp';
  if (publicContentPagesSet.has(pathKey)) return 'publicContent';
  if (workspacePagesSet.has(pathKey)) return 'workspaceApp';
  if (organisationAppPagesSet.has(pathKey)) return 'organisationApp';
  return 'paddlApp';
};

// Check if pathKey exists in pathLinks object
var pathKeyExists = function pathKeyExists(pathKey) {
  return Object.prototype.hasOwnProperty.call(pathLinks, pathKey);
};

// Get the prefix for the given pathKey
var pathKeyPrefix = function pathKeyPrefix(pathKey) {
  if (!process.env.NODE_ENV) throw new Error(invalidNodeEnvErrorMessage);
  return packagePrefixes[process.env.NODE_ENV][pathKeyToPackage(pathKey)];
};

// Format the query parameters and return them as a string
var formatQueryParameters = function formatQueryParameters(queryParameters) {
  var splittedParameter = Object.entries(queryParameters);
  return splittedParameter.length ? "?".concat(splittedParameter.map(function (_ref20) {
    var _ref21 = _slicedToArray(_ref20, 2),
      key = _ref21[0],
      _ref21$ = _ref21[1],
      value = _ref21$ === void 0 ? '' : _ref21$;
    return "".concat(key, "=").concat(value);
  }).join('&')) : '';
};

// Get the URL string for the given pathKey, pathArgs and queryParameters
export var urlStringForPathKey = function urlStringForPathKey(pathKey) {
  var pathArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var queryParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!pathKeyExists(pathKey)) return pathKey;
  return "".concat(pathKeyPrefix(pathKey), "/").concat(pathLinks[pathKey](pathArgs)).concat(formatQueryParameters(queryParameters));
};

// Redirect to the URL for the given pathKey, pathArgs and queryParameters
export var hardRedirect = function hardRedirect(pathKey) {
  var pathArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var queryParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!pathKeyExists(pathKey)) window.location.href = pathKey;
  window.location.href = urlStringForPathKey(pathKey, pathArgs, queryParameters);
};

// Check if the given pathKey is in the same package
export var linkInSamePackage = function linkInSamePackage(pathKey) {
  if (!pathKeyExists(pathKey)) throw new Error(invalidPathKeyErrorMessage);
  var packageName = process.env.PACKAGE_NAME || 'UNKNOWN';
  if (Object.prototype.hasOwnProperty.call(pathsInPackage, packageName)) {
    return pathsInPackage[packageName].has(pathKey);
  }
  return false;
};

// Get the link as a function that either calls the provided callback or
// redirects to the URL for the given pathKey, pathArgs and queryParameters
export var linkAsFunction = function linkAsFunction(pathKey) {
  var pathArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var funcCallback = arguments.length > 2 ? arguments[2] : undefined;
  if (!pathKeyExists(pathKey)) throw new Error(invalidPathKeyErrorMessage);
  return linkInSamePackage(pathKey) ? funcCallback : function () {
    return hardRedirect(pathKey, pathArgs);
  };
};